export default __webpack_public_path__ + "static/media/sidebar-bicocca.fdcecf96.jpg";